
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exhibitions/search",
      function () {
        return require("private-next-pages/exhibitions/search.tsx");
      }
    ]);
  